import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { NgxEditorModule } from 'ngx-editor';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { MaterialModule } from '../app-material.module';
import { PipesModule } from '../pipes/pipes.module';

// Shared components
import { ConfirmacionComponent } from '../home/confirmacion/confirmacion.component';
import { ConfirmarllamadaComponent } from '../home/confirmarllamada/confirmarllamada.component';
import { MoretextComponent } from '../home/moretext/moretext.component';
import { MapaDialogComponent } from '../components/mapa-dialog/mapa-dialog.component';
import { BitacoraDialogComponent } from '../components/bitacora-dialog/bitacora-dialog.component';
import { ComentarioDialogComponent } from '../components/comentario-dialog/comentario-dialog.component';
import { DescargarLotesComponent } from '../home/descargar-lotes/descargar-lotes.component';
import { FiltrosRepcampanaComponent } from '../home/filtros-repcampana/filtros-repcampana.component';
import { AlertaFlotanteComponent } from '../components/alerta-flotante/alerta-flotante.component';
import { AlarmaDetalleDialogComponent } from '../components/alerta-flotante/alarma-detalle-dialog/alarma-detalle-dialog.component';
import { CertificateBadgeComponent } from '../components/certificate-badge/certificate-badge.component';
import { InfoCardComponent } from '../components/info-card/info-card.component';
import { CertificateQueryComponent } from '../components/certificate-query/certificate-query.component';
import { ManejoConsentimientoComponent } from '../components/manejo-consentimiento/manejo-consentimiento.component';
import { WexllamadasComponent } from '../components/wexllamadas/wexllamadas.component';
import { AgendarCalendarComponent } from '../components/agendar-calendar/agendar-calendar.component';
import { PasswordnewComponent } from '../login/passwordnew/passwordnew.component';
import { ConsultaCertificadoNacimietoComponent } from '../home/consulta-certificado-nacimieto/consulta-certificado-nacimieto.component';
import { HistorialcertificadoComponent } from '../home/historialcertificado/historialcertificado.component';
import { VerCertificadoDialogComponent } from '../home/historialcertificado/ver-certificado-dialog/ver-certificado-dialog.component';

@NgModule({
  declarations: [
    ConfirmacionComponent,
    ConfirmarllamadaComponent,
    MoretextComponent,
    MapaDialogComponent,
    BitacoraDialogComponent,
    ComentarioDialogComponent,
    DescargarLotesComponent,
    FiltrosRepcampanaComponent,
    AlertaFlotanteComponent,
    AlarmaDetalleDialogComponent,
    CertificateBadgeComponent,
    InfoCardComponent,
    CertificateQueryComponent,
    ManejoConsentimientoComponent,
    WexllamadasComponent,
    AgendarCalendarComponent,
    PasswordnewComponent,
    ConsultaCertificadoNacimietoComponent,
    HistorialcertificadoComponent,
    VerCertificadoDialogComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxSpinnerModule,
    PipesModule,
    ColorPickerModule,
    NgScrollbarModule,
    PickerModule,
    MatButtonToggleModule,
    MatBadgeModule,
    NgxMatSelectSearchModule,
    TooltipModule,
    AngularFontAwesomeModule,
    NgxEditorModule,
    AngularEditorModule,
  ],
  exports: [
    // Re-export common modules so feature modules don't need to import them individually
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxSpinnerModule,
    PipesModule,
    ColorPickerModule,
    NgScrollbarModule,
    PickerModule,
    MatButtonToggleModule,
    MatBadgeModule,
    NgxMatSelectSearchModule,
    TooltipModule,
    AngularFontAwesomeModule,
    NgxEditorModule,
    AngularEditorModule,
    // Export shared components
    ConfirmacionComponent,
    ConfirmarllamadaComponent,
    MoretextComponent,
    MapaDialogComponent,
    BitacoraDialogComponent,
    ComentarioDialogComponent,
    DescargarLotesComponent,
    FiltrosRepcampanaComponent,
    AlertaFlotanteComponent,
    AlarmaDetalleDialogComponent,
    CertificateBadgeComponent,
    InfoCardComponent,
    CertificateQueryComponent,
    ManejoConsentimientoComponent,
    WexllamadasComponent,
    AgendarCalendarComponent,
    PasswordnewComponent,
    ConsultaCertificadoNacimietoComponent,
    HistorialcertificadoComponent,
    VerCertificadoDialogComponent,
  ],
  entryComponents: [
    ConfirmacionComponent,
    ConfirmarllamadaComponent,
    MoretextComponent,
    MapaDialogComponent,
    BitacoraDialogComponent,
    ComentarioDialogComponent,
    DescargarLotesComponent,
    FiltrosRepcampanaComponent,
    AlarmaDetalleDialogComponent,
    PasswordnewComponent,
    VerCertificadoDialogComponent,
  ]
})
export class SharedModule { }
